import SPADESLOTActions from './SPADESLOTActions'

export default class SPADEEGAMEActions extends SPADESLOTActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'EGAME',
      gameCode: 'SG-EGAME-003',
      platform: 'SPADE',
    }

    this.gameName = 'Space Crasher'
  }
}
